const dashboardConstants = {
  GET_ALL_TERMINAL_SUMMARY_START: "GET_ALL_TERMINAL_SUMMARY_START",
  GET_ALL_TERMINAL_SUMMARY_SUCCESS: "GET_ALL_TERMINAL_SUMMARY_SUCCESS",
  GET_ALL_TERMINAL_SUMMARY_FAILED: "GET_ALL_TERMINAL_SUMMARY_FAILED",
  FILTER_TERMINAL_SUMMARY_START: "FILTER_TERMINAL_SUMMARY_START",
  FILTER_TERMINAL_SUMMARY_SUCCESS: "FILTER_TERMINAL_SUMMARY_SUCCESS",
  FILTER_TERMINAL_SUMMARY_FAILED: "FILTER_TERMINAL_SUMMARY_FAILED",
};

export default dashboardConstants;
